import React, { useState } from 'react';
import './style.css';
import QCP_API from 'api/qcpApi';
import { useFetch } from '@hooks/useAuthApi';
import '../cards/DarkCard.scss';

const Comments = ({comment}) => {

  // Full list of comments
 

console.log("comment", comment)

  // State to control how many comments are displayed
  const [visibleComments, setVisibleComments] = useState(8);

  // Function to show 5 more comments
  const showMoreComments = () => {
    setVisibleComments(prev => prev + 5);
  };

  return (
    <React.Fragment>
      <div className='w-full rounded-md bg-gray-50 overflow-hidden border p-3 dark-bg'>
        <div className='w-full flex items-center mb-2'>
          <p className='mb-0 text-md font-semibold'>Comments</p>
        </div>
        
        {/* Scrollable Container with Fixed Height */}
        <div className="max-h-[89vh] min-h-[3.3vh] overflow-y-auto pr-2 custom-scrollbar">
            {/* Render only the number of comments controlled by visibleComments */}
            {comment && comment?.slice(0, visibleComments).map((comment) => (
            <div key={comment.id} className="bg-gray-100 hover:bg-gray-200 hover:cursor-pointer rounded px-3 py-2 mt-2 border dark-bg">
                <div className='flex items-center justify-between mb-2'>
                <div className='flex items-start gap-x-3'>
                    <p className='font-semibold mb-0'>{comment?.commentedBy?.firstName + " " + comment?.commentedBy?.lastName}</p>
                </div>
                <p className='text-xs mb-0'>{comment.createdDateUTC.split("T")[0]}</p>
                </div>
                <p className='mb-0 text-sm'>{comment.commentText}</p>
            </div>
          ))}
        </div>
        {/* Show "See 5 more comments" button if there are more comments to show */}
        {visibleComments < comment?.data?.length && (
            <button 
                onClick={showMoreComments} 
                className="mt-4 hover:underline text-sm">
                See 5 more comments
            </button>
        )}

      </div>
    </React.Fragment>
  );
}

export default Comments;